<template>
  <BillingProductsAgreement
    v-if="showBillingProductAgreement"
    :billing-products="billingProducts"
    :order-id="this.$route.params.orderID"
    @closeModal="toggleShowBillingProductModal"
    @continue="continueAddToCart"
  />
  <div
    ref="productElement"
    :class="[
      listView ? 'flex flex-row w-full' : 'flex flex-col min-h-[400px]',
      isInCart(product) ? 'border-primary-800' : '',
    ]"
    class="p-[10px] lg:p-0 bg-white border border-grays-400 rounded hover:shadow-cards_hover relative cursor-pointer"
    @click="handleOpenModal(product)"
    @mouseenter="
      (product.product.sub_items.length
        ? product.product.images.concat(
            product.product.sub_items
              .map((item) => (item.product ? item.product.images : item.images))
              .flat()
          )
        : product.product.images
      ).length
        ? (hover = true)
        : ''
    "
    @mouseleave="hover = false"
  >
    <div
      v-if="outOfStock"
      class="absolute w-full h-full bg-white bg-opacity-70 z-30 flex justify-center pt-[70px]"
    >
      <div class="text-primary-900 font-medium text-lg">אזל מהמלאי</div>
    </div>

    <!-- <product-badge :product="product.product" /> -->

    <!-- special price badge -->
    <!-- z-20 matches button-like below (the mirrored top-right corner icon) -
         same tier as the rest of the card's own overlay UI, and below the
         site's sticky chrome (category bar, sale tabs, header). At z-[60] it
         used to out-rank all of those, so once a card scrolled to where it
         should tuck under the sticky header, the badge kept poking through. -->
    <div
      v-if="hasSpecialPrice"
      class="absolute top-[12px] -left-[10px] left-0 z-20 pointer-events-none"
    >
      <div
        class="flex items-center gap-1 h-8 w-[119px] px-2 rounded-tl-none rounded-tr-[5px] rounded-br-[5px] rounded-bl-none bg-complementary-100 text-complementary-700 font-bold text-base leading-none"
      >
        <img
          src="~@/assets/icons/global/hotel_class.svg"
          alt=""
          class="w-4 h-4"
        />
        <span>מחיר מיוחד</span>
      </div>
    </div>
    <product-badge v-else :product="product.product" />

    <!-- img/slder plh -->
    <div
      :class="[
        listView
          ? 'relative w-[100px] md:w-[244px] md:h-[219px] flex items-center justify-center'
          : 'relative w-full h-[175px] flex items-center justify-center',
      ]"
    >
      <button-like
        v-if="!product.organization_item"
        :like="product.favourite"
        class="absolute z-20 top-[16px] right-[14px]"
        @click.stop
        @toggle-like="toggleLike(product)"
      />
      <!-- <button-tooltip-hayadata class="!absolute z-20 bottom-[22px] right-[8.5px] w-fit" /> -->
      <!-- <div class="flex w-full justify-center items-center text-center">
        no photo
      </div> -->
      <transition
        enter-active-class="transition-opacity duration-500"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="transition-opacity duration-500"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div
          v-if="showPopUp && live_help"
          class="text-complementary-100 absolute bottom-0 right-2 z-10 bg-complementary-700 rounded flex flex-row gap-1 pl-2 pr-2.5 py-1"
        >
          <span class="font-medium"
            ><span class="font-bold">טוב לדעת!</span> טולטיפ</span
          >
          <span class="material-symbols-rounded text-base">live_help</span>
        </div>
      </transition>
      <img
        v-if="
          !(
            (product.product.sub_items.length
              ? product.product.images.concat(
                  product.product.sub_items
                    .map((item) =>
                      item.product ? item.product.images : item.images
                    )
                    .flat()
                )
              : product.product.images
            ).length > 1
          )
        "
        :class="[
          'relative max-w-full max-h-full left-0 top-0 object-contain rounded',
          listView ? 'rounded-l-[0]' : 'rounded-b-[0]',
        ]"
        :src="`https://images.mishnatyosef.org/images/items/${product.product.thumb_featured_image}`"
        alt="Product"
      />
      <swiper
        v-else
        ref="mySwiper"
        :class="[
          'mySwiper rounded h-full',
          listView ? 'rounded-l-[0]' : 'rounded-b-[0]',
        ]"
        :loop="true"
        :modules="modules"
        :navigation="{ nextEl: '.arrow-right', prevEl: '.arrow-left' }"
        :pagination="{ bulletActiveClass: 'bulletActive' }"
      >
        <swiper-slide
          v-for="image in this.product.product.sub_items.length
            ? this.product.product.images.concat(
                this.product.product.sub_items
                  .map((item) =>
                    item.product ? item.product.images : item.images
                  )
                  .flat()
              )
            : this.product.product.images"
          :key="image"
          ref="mySwiperSlide"
          class="!w-full flex justify-center items-center h-full"
        >
          <img
            :class="[
              'relative max-h-full max-w-full left-0 top-0 object-cover',
            ]"
            :src="`https://images.mishnatyosef.org/images/items/${image.filename}_small.${image.extension}`"
            alt="item"
          />
        </swiper-slide>

        <div
          class="absolute w-full h-fit top-0 bottom-0 m-auto flex justify-between items-center z-20"
        >
          <button class="arrow-left arrow" @click.stop>
            <span class="material-symbols-rounded text-grays-700"
              >chevron_right</span
            >
          </button>
          <button class="arrow-right arrow" @click.stop>
            <span class="material-symbols-rounded text-grays-700"
              >chevron_left</span
            >
          </button>
        </div>
      </swiper>
      <img
        v-if="organizationLogo"
        :src="organizationLogo"
        :alt="product.organization?.name"
        class="absolute z-20 bottom-2 left-2 w-14 h-14 rounded-full bg-white border border-grays-300 p-1 object-contain shadow"
      />
    </div>
    <div class="flex flex-col flex-1">
      <!-- product description -->
      <div
        :class="
          listView
            ? 'md:flex flex-row justify-start items-center flex-1 px-[8.5px]'
            : 'md:flex flex-col flex-1 px-[8.5px] pb-[7.5px]'
        "
      >
        <div :class="['flex flex-col', listView ? 'max-w-[273px]' : '']">
          <!-- name -->
          <div class="flex items-start gap-4 justify-between">
            <p
              class="text-primary-700 text-lg font-bold max-w-[60%] break-words"
            >
              {{ product.name }}
            </p>
            <product-icons :product="product" class="flex-shrink-0" />
          </div>
          <span
            v-if="product.product.item_tag"
            :title="product.product.item_tag.description"
            class="inline-block bg-grays-300 text-grays-700 text-xs font-medium rounded px-2 py-[2px] mt-1 cursor-default self-start"
            >{{ product.product.item_tag.tag }}</span
          >
          <!-- amount -->
          <p class="text-grays-700 text-base font-medium my-[4px]">
            {{ computedUnit }}
          </p>
          <div
            v-if="isLocalEnv"
            class="text-xs text-grays-700 bg-grays-100 px-2 py-1 rounded"
          >
            {{ product.itemID }}
          </div>
          <!-- description -->
          <product-gallery-description
            :product="product"
            @show-more-clicked="handleOpenModal(product)"
          />
        </div>
        <!-- price -->
        <p v-if="!listView" class="text-primary-900 text-lg font-bold my-[8px]">
          {{
            product.product.sub_items.length &&
            Math.max(...product.product.sub_items.map((item) => item.price)) !==
              Math.min(...product.product.sub_items.map((item) => item.price))
              ? `₪ ${Math.max(
                  ...product.product.sub_items.map((item) => item.price)
                )} - ₪ ${Math.min(
                  ...product.product.sub_items.map((item) => item.price)
                )} `
              : `₪ ${product.price.toFixed(2)}`
          }}
          <span
            v-if="hasSpecialPrice"
            class="relative inline-block text-grays-500 font-medium text-base ml-1"
          >
            ₪{{ product.regular_price.toFixed(2) }}
            <span
              class="absolute inset-0 flex items-center justify-center pointer-events-none"
            >
              <span
                class="w-full h-[2px] bg-red-500 -rotate-12 transform origin-center"
              ></span>
            </span>
          </span>

          <span class="text-sm font-regular">
            {{ computedPriceForweight }}
          </span>
        </p>
        <span class="text-sm font-light" v-if="hasSpecialPrice"
          >תוקף המחיר המיוחד עד {{ moment(sale.end).format("D/MM/Y") }}
        </span>
        <!-- product details -->
        <div
          :class="[
            'md:flex flex-row gap-5',
            listView ? 'md:mr-[45px] md:mt-[50px]' : '',
          ]"
        >
          <div v-if="product.details" class="flex flex-col gap-[4px] w-[50px]">
            <p class="text-grays-600 text-sm font-medium">פרטים</p>
            <p class="text-grays-900 text-base font-regular">
              {{ product.details }}
            </p>
          </div>
          <div
            v-if="
              product.manufacturer &&
              product.details &&
              (product.manufacturer.name || product.manufacturer.logo)
            "
            class="flex flex-col md:items-center gap-[4px]"
          >
            <p class="text-grays-600 text-sm font-medium">חברה</p>
            <p class="text-grays-900 text-base font-regular">
              <img
                v-if="product.manufacturer.logo"
                :alt="product.manufacturer.name"
                :src="
                  'https://images.mishnatyosef.org//images/brands/' +
                  product.manufacturer.logo
                "
                class="h-[30px]"
              />
              <span v-else>
                {{ product.manufacturer.name }}
              </span>
            </p>
          </div>
          <div
            v-if="product.product.sub_items.length > 1"
            class="flex flex-col gap-[4px]"
          >
            <p class="text-grays-600 text-sm font-medium">וריאציות</p>
            <p class="text-grays-900 text-base font-regular">
              מגוון {{ product.plural_attribute_name }}
            </p>
          </div>
        </div>
      </div>
      <!-- product action btns -->
      <div
        :class="[
          listView
            ? 'flex-row space-between justify-between w-full'
            : 'flex-row-reverse',
        ]"
        class="lg:flex justify-end lg:justify-between relative gap-2 items-center pt-[7.5px] lg:mt-[12.5px] bg-grays-200 rounded-b"
        @click.stop
      >
        <tooltip-user
          v-if="tooltipParentProduct"
          class="absolute z-[60] right-[102%] bottom-[10px] self-end md:block hidden"
          direction="right"
          type="ParentProduct"
          @close="closeTooltipParentProduct"
        />
        <p
          v-if="listView"
          class="px-[7.5px] pb-[7.5px] text-primary-900 text-lg font-bold my-[8px]"
        >
          {{
            product.product.sub_items.length &&
            Math.max(...product.product.sub_items.map((item) => item.price)) !==
              Math.min(...product.product.sub_items.map((item) => item.price))
              ? `₪ ${Math.max(
                  ...product.product.sub_items.map((item) => item.price)
                )} - ₪ ${Math.min(
                  ...product.product.sub_items.map((item) => item.price)
                )} `
              : `₪ ${product.price.toFixed(2)}`
          }}
          <span class="text-sm font-regular"
            >{{ computedPriceForweight }}
          </span>
        </p>
        <div
          :class="[
            isInCart(product)
              ? ' bg-primary-200 w-full py-[7.5px] !justify-between pr-6'
              : 'px-[7.5px] pb-[7.5px] ',
            product.product?.sub_items?.length &&
            product.product.sub_items.some((item) => isInCart(item))
              ? 'bg-primary-200 w-full py-[7.5px] !justify-between pr-6'
              : 'w-fit',
          ]"
          class="flex justify-end lg:justify-normal gap-2 flex-row-reverse z-30 items-center"
        >
          <div v-if="isInCart(product)" class="flex flex-row gap-[8px]">
            <button-text
              v-if="amount !== product.amount || processing"
              class="text-primary-300 font-medium text-base"
              @click="updateAmount"
              :disabled="processing || requestIsActive"
            >
              לעדכן כמות מוצר
            </button-text>
            <button-text
              v-else
              class="text-primary-300 font-medium text-base z-30"
              @click="deleteProduct"
              :disabled="processing"
            >
              <span class="material-symbols-rounded text-xl">delete</span>
              למחוק מוצר
            </button-text>
          </div>
          <div
            v-else
            :class="[
              'flex flex-row relative items-center gap-2',
              index === 2 && step === 2 ? 'z-[51]' : 'z-10',
            ]"
          >
            <onboarding-modal
              v-if="step === 2 && showOnboarding && index === 2"
            ></onboarding-modal>
            <div
              v-if="
                product.product?.sub_items?.length &&
                product.product.sub_items.some((item) => isInCart(item))
              "
              class="gap-2 bg-success text-white h-fit flex flex-row items-center rounded-full px-2"
            >
              <span class="material-symbols-rounded text-xl">check</span>
              {{
                product.product.sub_items
                  .filter((item) => isInCart(item))
                  .map((item) => item.attribute)
                  .join(",")
              }}
            </div>
            <button-cta
              :disabled="outOfStock || processing"
              @click="handleAddToCart()"
            >
              {{
                product.product.sub_items.length
                  ? `בחר ${product.attribute_name || ""}`
                  : "להוסיף להזמנה "
              }}
            </button-cta>
          </div>
          <input-amount
            v-if="!product.product.sub_items.length"
            v-model="amount"
            :class="isInCart(product) ? 'bg-white' : ''"
            :max-amount="computedMaxAmount"
            :out-of-stock="
              product.available !== null && product.available === 0
            "
            @valueChanged="handleValueChanged"
          />
          <span
            v-if="isInCart(product)"
            class="material-symbols-rounded bg-success h-6 w-6 flex items-center justify-center rounded-full text-white text-base p-[1px]"
            >check</span
          >
        </div>
      </div>
    </div>
  </div>
  <!-- badge text/icon -->
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation, Pagination } from "swiper";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import axiosInstance from "../../helpers/axios.js";
import eventBus from "@/helpers/eventBus";
import { reportRemoveFailure } from "@/helpers/removeItemFailure";
import { isSoldOut, variantIsSoldOut } from "@/helpers/stock";
import ButtonSecondary from "@/components/Global/ButtonSecondary.vue";
import ButtonText from "@/components/Global/ButtonText.vue";
import ProductGalleryDescription from "@/components/Order/ProductGalleryDescription.vue";
import ProductBadge from "@/components/Order/ProductBadge.vue";
import ProductIcons from "@/components/Order/ProductIcons.vue";
import ButtonLike from "@/components/Global/ButtonLike.vue";
import ButtonCta from "@/components/Global/ButtonCTA.vue";
import InputAmount from "@/components/Global/InputAmount.vue";
import OnboardingModal from "@/components/Onboarding/Onboarding.vue";
import BillingProductsAgreement from "@/components/Modals/BillingProductsAgreement.vue";
import TooltipUser from "@/components/Tooltip/TooltipUser.vue";
import moment from "moment";
import "moment/dist/locale/he";
import dayjs from "dayjs";
import "dayjs/locale/he";
import { forEach } from "lodash";

export default {
  name: "product",
  components: {
    TooltipUser,
    BillingProductsAgreement,
    OnboardingModal,
    InputAmount,
    ButtonCta,
    ButtonLike,
    ProductBadge,
    ProductIcons,
    ProductGalleryDescription,
    ButtonText,
    ButtonSecondary,
    Swiper,
    SwiperSlide,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    sale: {
      type: Object,
      required: true,
    },
    listView: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
    },
    billingProducts: {
      type: Array,
      default: [],
    },
  },
  emits: ["tooltipScaleTrigger"],
  data() {
    return {
      amount: this.product.amount || 1,
      originalAmount: this.product.amount,
      buttonDisabled: true,
      showPopUp: false,
      outOfStock: false,
      requestIsActive: false,
      hover: false,
      showBillingProductAgreement: false,
      tooltipParentProduct: false,
      processing: false,
    };
  },
  methods: {
    getTooltipInfo() {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      if (Object.keys(user).length === 0) {
        return;
      }
      const tooltips = user.tooltips;

      const tooltipParentProduct = tooltips.find(
        (item) => item.name === "Parent product"
      );

      if (tooltipParentProduct && !tooltipParentProduct.finished) {
        this.setUpObserver(tooltipParentProduct);
      }
    },
    closeTooltipParentProduct() {
      this.tooltipParentProduct = false;
    },
    setUpObserver(tooltip) {
      const options = {
        root: null,
        rootMargin: "0px",
        threshold: 1,
      };

      this.observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (
            entry.isIntersecting &&
            this.hasChildItems(this.product) &&
            !sessionStorage.getItem("tooltipShownForSubItems")
          ) {
            sessionStorage.setItem("tooltipShownForSubItems", "true");
            this.tooltipParentProduct = true;
            observer.unobserve(entry.target);
            axiosInstance
              .post(`/profile/finish_tooltip/${tooltip.id}`)
              .then(() => {
                const latestData = JSON.parse(localStorage.getItem("user"));
                const latestTooltips = latestData.tooltips;
                const latestTooltipSalesBoard = latestTooltips.find(
                  (item) => item.name === tooltip.name
                );
                latestTooltipSalesBoard.finished = true;
                localStorage.setItem("user", JSON.stringify(latestData));
                setTimeout(() => {
                  this.tooltipParentProduct = false;
                }, 1000 * 30);
              });
          }
        });
      }, options);

      this.observer.observe(this.$refs.productElement);
    },
    hasChildItems(product) {
      return (
        product.product.sub_items &&
        product.product.sub_items.length > 0 &&
        !this.outOfStock
      );
    },
    toggleShowBillingProductModal() {
      this.showBillingProductAgreement = !this.showBillingProductAgreement;
    },
    ...mapMutations({
      setProduct: "productModal/setProduct",
      toggleShowModal: "order/toggleShowModal",
      removeFromCart: "cart/removeFromCart",
      setImagePath: "order/setImagePath",
      setShowBillingProductAgreement: "order/setShowBillingProductAgreement",
    }),
    ...mapActions({
      toggleIsModalVisible: "productModal/toggleIsModalVisible",
      addToCart: "cart/addToCart",
      showToast: "orderToast/showToast",
      updateAmountInCart: "cart/updateAmount",
    }),
    handleOpenModal(product) {
      if (product.organization_item) return;
      this.toggleIsModalVisible();
      this.setProduct(product);
    },
    zoomImage() {
      const images = this.product.product.sub_items.length
        ? this.product.product.images.concat(
            this.product.product.sub_items
              .map((item) => (item.product ? item.product.images : item.images))
              .flat()
          )
        : this.product.product.images;
      if (images.length > 1) {
        const swiperInstance =
          this.$refs.mySwiperSlide[0]?.swiperRef?._rawValue;
        const currentIndex = swiperInstance?.realIndex;
        const currentImage = images[currentIndex % images.length]; // Modulo for looping
        this.setImagePath(
          `https://images.mishnatyosef.org/images/items/${currentImage.filename}.${currentImage.extension}`
        );
      } else {
        // If only one image, use that
        this.setImagePath(
          `https://images.mishnatyosef.org/images/items/${this.product.product.featured_image}`
        );
      }
    },
    async checkCompleteRegistration() {
      if (!(this.fname && this.lname && this.allPhoneNumbers.length)) {
        const response = await axiosInstance.get("/profile");
        const user = response.data;
        this.setFname(user.fname);
        this.setLname(user.lname);
        user.phones.forEach((phone, index) => {
          this.setAllPhoneNumbers({ index, value: phone.tel });
        });
        if (!(this.fname && this.lname && this.allPhoneNumbers.length)) {
          return false;
        }
      }
      return true;
    },
    async handleAddToCart() {
      this.processing = true;
      if (this.requestIsActive) {
        return;
      }
      this.requestIsActive = true;

      if (this.product.weighable) {
        this.$emit("tooltipScaleTrigger");
      }

      if (this.product.product.sub_items.length) {
        this.handleOpenModal(this.product);
        this.requestIsActive = false;
        this.processing = false;
        return void 0;
      }

      if (!(await this.checkCompleteRegistration())) {
        this.toggleShowModal();
        this.requestIsActive = false;
        this.processing = false;
        return void 0;
      }

      if (
        !this.product.organization_item &&
        !this.billingProductIsAgreed &&
        !this.cart.some((product) => !product.organization_item)
      ) {
        this.toggleShowBillingProductModal();
        return;
      }

      await this.continueAddToCart();
    },
    async continueAddToCart() {
      this.requestIsActive = true;
      this.product.amount = this.amount;
      const productDetails = {
        ...this.product,
        amount: this.amount,
        itemID: this.product.itemID,
        item_salesID: this.product.item_salesID,
        name: this.product.name,
        featured_image: this.product.product.featured_image,
        images: this.product.product.images,
        price1: this.product.price,
        id: this.product.id,
      };
      if (this.isLocalEnv) {
        productDetails.itemId = this.product.itemID;
      }
      try {
        const { data } = this.product.organization_item
          ? await axiosInstance.post(
              `/orders/${this.$route.params.orderID}/organization-products`,
              { item_id: this.product.itemID, amount: this.amount }
            )
          : await axiosInstance.post(
              `/add_item/${this.$route.params.orderID}`,
              productDetails
            );
        this.addToCart(productDetails);

        if (!this.product.organization_item && data.length > 1) {
          data.pop();
          data.forEach((item) => {
            this.addToCart({ specialProduct: true, ...item });
          });
        }
        this.showToast({ message: this.product.name, type: "add" });
        this.requestIsActive = false;
        this.processing = false;
      } catch (e) {
        this.showToast({
          message: e.response.data.message,
          type: "error",
        });
        if (e.response.data.message === "המכירה סגורה להזמנות.") {
          setTimeout(() => {
            this.$router.push("/");
          }, 3000);
        }
        // This product belongs to a sale other than the one the order is
        // for - the list on screen is stale. Let the page refill itself.
        if (e.response?.data?.code === "sale_mismatch") {
          eventBus.emit("saleMismatch");
        }
        this.requestIsActive = false;
        this.processing = false;
      }
    },
    async toggleLike(product) {
      if (product.organization_item) return;
      // Toggle the favourite property of the product
      product.favourite = product.favourite === 1 ? 0 : 1;
      try {
        await axiosInstance.get(`/toggle_favourites/${product.id}`);
      } catch (e) {
        this.processing = false;
        console.error(e);
      }
    },
    async deleteProduct() {
      this.processing = true;
      try {
        if (this.product.organization_item) {
          await axiosInstance.delete(
            `/orders/${this.$route.params.orderID}/organization-products/${this.product.itemID}`
          );
        } else {
          await axiosInstance.post(
            `/remove_item/${this.$route.params.orderID}/${this.product.item_salesID}`,
            this.product
          );
        }
        this.removeFromCart(this.product);
        this.product.amount = 1;
        await this.showToast({
          message: this.product.full_name || this.product.product.full_name,
          type: "danger",
        });
        this.processing = false;
      } catch (e) {
        this.processing = false;
        reportRemoveFailure(e, this.showToast);
      }
    },
    async updateAmount() {
      this.processing = true;
      this.requestIsActive = true;
      if (this.product.amount !== this.amount) {
        this.product.amount = this.amount;
        try {
          if (this.product.organization_item) {
            await axiosInstance.put(
              `/orders/${this.$route.params.orderID}/organization-products/${this.product.itemID}`,
              { amount: this.amount }
            );
          } else {
            await axiosInstance.post(
              `/update_item/${this.$route.params.orderID}`,
              this.product
            );
          }
          await this.updateAmountInCart({
            id: this.product.id,
            itemID: this.product.itemID,
            organization_item: this.product.organization_item,
            amount: this.amount,
          });
          this.processing = false;
          this.requestIsActive = false;
          this.showPopUp = true;

          this.showToast({
            message: this.product.name,
            type: "update",
            amount: this.amount,
          });
          setTimeout(() => {
            this.showPopUp = false;
          }, 3000);
        } catch (e) {
          await this.showToast({
            message: e.response.data.message,
            type: "error",
          });
          if (e.response.data.message === "המכירה סגורה להזמנות.") {
            setTimeout(() => {
              this.$router.push("/");
            }, 3000);
          }
          this.processing = false;
          console.error(e);
        }
      }
    },
    moment: function (param1, param2) {
      return moment(param1, param2);
    },
    handleValueChanged() {
      this.buttonDisabled = this.originalAmount === this.amount;
    },
    ...mapMutations({
      setFname: "user/setFname",
      setLname: "user/setLname",
      setAllPhoneNumbers: "user/setAllPhoneNumbers",
    }),
  },
  computed: {
    ...mapGetters({
      noLimit: "user/getNoLimit",
    }),
    // A sold-out line can only go down, so its cap is what the order
    // already holds. isSoldOut also covers the `false` the API sends when a
    // rule settled it, which the bare `=== 0` check here used to miss.
    computedMaxAmount() {
      if (isSoldOut(this.product)) {
        return this.product.amount;
      } else if (this.noLimit !== 0) {
        return 99999;
      } else {
        return this.product.max_per_man;
      }
    },
    hasSpecialPrice() {
      return (
        this.product.regular_price > 0 &&
        this.product.price > 0 &&
        this.product.regular_price > this.product.price
      );
    },
    organizationLogo() {
      return this.product.organization_item
        ? this.product.organization?.branding?.logo_url || ""
        : "";
    },
    isLocalEnv() {
      return import.meta.env.VITE_ENV === "local";
    },
    // hasSpecialPrice() {
    //   const price = Number(this.product?.price);
    //   const regular = Number(
    //     this.product?.regular_price ?? this.product?.product?.regular_price
    //   );
    //   return (
    //     Number.isFinite(price) && Number.isFinite(regular) && regular > price
    //   );
    // },
    computedUnit() {
      if (!this.product?.item_type) {
        return undefined;
      }
      const type =
        this.product.item_type !== null
          ? this.product.item_type.name + " "
          : "";
      const units = this.product.units > 0 ? this.product.units + " " : "";
      const approx = this.product.approx !== 0 ? " כ-" : "";
      const unit_type = this.product?.item_unit?.name || "";
      let price = "";
      return type + approx + units + unit_type + price;
    },
    computedPriceForweight() {
      const units = this.product.units > 0 ? this.product.units + " " : "";
      const unit_type = this.product?.item_unit?.name || "";
      let price = "";
      if (Number(this.product.units) !== 0) {
        if (this.product.units_type == 10 && this.product.units < 1) {
          price =
            " (₪" +
            parseFloat(this.product.price / units / 10).toFixed(2) +
            " ל-100 גרם)";
        } else if (this.product.units_type == 16 && this.product.units < 1) {
          price =
            " (₪" +
            parseFloat(this.product.price / units / 10).toFixed(2) +
            " ל-100 מ״ל)";
        } else {
          price =
            " (₪" +
            parseFloat(this.product.price / units).toFixed(2) +
            " ל" +
            unit_type +
            ")";
        }
      }
      return price;
    },
    ...mapGetters({
      isInCart: "cart/isInCart",
      lname: "user/getLname",
      fname: "user/getFname",
      street: "user/getStreet",
      city: "user/getCity",
      allPhoneNumbers: "user/getAllPhoneNumbers",
    }),
    ...mapState({
      cart: (state) => state.cart.cart,
      billingProductIsAgreed: (state) => state.order.billingProductIsAgreed,
      showOnboarding: (state) => state.onboarding.show,
      step: (state) => state.onboarding.step,
    }),
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  mounted() {
    if (
      this.product.product.sub_items &&
      this.product.product.sub_items.length
    ) {
      if (!sessionStorage.getItem("tooltipShownForSubItems")) {
        this.getTooltipInfo();
      }
      this.outOfStock = this.product.product.sub_items.every((item) =>
        variantIsSoldOut(this.product, item.attribute)
      );
    } else {
      this.outOfStock = isSoldOut(this.product);
    }
  },
  watch: {
    product: {
      deep: true,
      handler(newValue) {
        if (this.originalAmount !== newValue.amount) {
          this.originalAmount = newValue.amount;
          this.amount = newValue.amount;
        }
      },
    },
  },
  setup() {
    return {
      modules: [Navigation, Pagination],
    };
  },
};
</script>

<style>
.swiper-pagination-bullet {
  background: #e4e4e4 !important;
  opacity: 1 !important;
  width: 4px !important;
  height: 4px !important;
}

.bulletActive {
  background: #3f238b !important;
  opacity: 1 !important;
  width: 4px !important;
  height: 4px !important;
}
</style>
